module.exports = __webpack_public_path__ + "static/media/ajb-one-large-min.9178d62f.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/ajb/ajb-one-large-min.png
// module id = 804
// module chunks = 0